import { motion } from 'framer-motion';
import { useReducedMotion } from '../../hooks/useReducedMotion';
import { hudCopy } from '../content';
import { DataRing, HudPanel, MetricBar, ModuleHeader, ScannerOverlay, SystemFrame } from '../primitives';

export const VerifiedOperationsScreen = () => {
  const reducedMotion = useReducedMotion();

  return (
    <SystemFrame id="verified-ops" className="min-h-[calc(100vh-6.5rem)] pt-24">
      <HudPanel pulse className="relative">
        <ScannerOverlay tone="normal" />
        <ModuleHeader
          index="SCREEN 06"
          title={hudCopy.trust.heading}
          subtitle={hudCopy.trust.subtitle}
          tag="ASSURANCE CONSOLE"
          status={hudCopy.microLabels.verified}
        />

        <div className="mt-7 grid gap-4 lg:grid-cols-[1fr_0.9fr]">
          <HudPanel pulse className="bg-brand-panel-2/72">
            <p className="hud-micro text-brand-lime">Verification Matrix</p>
            <ul className="mt-4 grid gap-3" aria-label="Operational trust checks">
              {hudCopy.trust.checks.map((check, index) => (
                <li key={check} className="flex items-start gap-3 rounded-lg border border-brand-lime/18 bg-brand-panel/70 px-3 py-2">
                  <motion.span
                    className="mt-1.5 h-2 w-2 rounded-full bg-brand-lime"
                    animate={reducedMotion ? undefined : { opacity: [0.35, 1, 0.45], scale: [0.85, 1.3, 0.9] }}
                    transition={{ duration: 1.7, repeat: Infinity, delay: index * 0.12 }}
                  />
                  <span className="text-sm text-brand-text-2">{check}</span>
                </li>
              ))}
            </ul>
          </HudPanel>

          <div className="grid gap-4">
            <HudPanel pulse className="bg-brand-panel-2/72">
              <p className="hud-micro text-brand-lime">Operational Confidence</p>
              <div className="mt-4 grid grid-cols-3 gap-3">
                <DataRing value={89} label="Quality" size={86} />
                <DataRing value={93} label="Trust" size={86} />
                <DataRing value={84} label="Continuity" size={86} />
              </div>
            </HudPanel>
            <HudPanel pulse className="space-y-4 bg-brand-panel-2/72">
              {hudCopy.trust.stats.map((stat, index) => (
                <MetricBar key={stat.label} label={stat.label} value={88 - index * 8} />
              ))}
            </HudPanel>
          </div>
        </div>
      </HudPanel>
    </SystemFrame>
  );
};
